import asyncComponent from '../../components/AsyncComponent';

const ClauseList = asyncComponent(() => import('../../containers/Clause/ClauseList'));

export default ClauseList;
